import { environment } from "src/environments/environment";



export var url = environment.serverUrl;
export var url_ws = environment.serverUrl;
export var urlUpload = environment.urlUpload;

export var valorAnd =" ";
export var valorOr =",";
